import styled from 'styled-components';

export const InputUpper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100%;
`;

export default InputUpper;
